export default "__VITE_ASSET__CQpONKJ9__"